import React from 'react'
import { Dialog } from '@leverege/ui-elements'

export default function RemoveDialog( props ) {

  const { onOkay, onClose, attribute, blueprint, ...rest } = props 

  const message = `This will delete the attribute ${attribute.name} and it’s metadata from the blueprint. Device Data will not be changed, but this attribute will not longer be visible from UIs.`

  const nOnOkay = () => {
    onOkay()
    onClose()
  }

  return (
    <Dialog.Question
      {...rest}
      variant="dialogMedium"
      title={`Remove ${attribute.name} from ${blueprint.alias || blueprint.id}?`}
      message={message}
      onOkay={nOnOkay}
      onCancel={onClose}
      okay="Delete"
      okayVariant="primaryDestructive" />
    )
}
